import React from 'react';
import { withStyles, Grid, Typography, } from '@material-ui/core';
import PropTypes from 'prop-types';

class RaceEventEnd extends React.Component {
    render() {
        const { type } = this.props;
        return (
            <Grid container direction='row' alignItems='center' justify='center' style={{ flex: 1 }}>
                <Grid container direction='column' alignItems='center' style={{ width: 25 }}>
                    <Grid style={{ backgroundColor: '#E2E2E2', width: 1, height: 10 }}></Grid>
                    <Typography style={{ color: '#878787', fontSize: 12 }}>{type}</Typography>
                    <Grid style={{ backgroundColor: '#E2E2E2', width: 1, height: 10 }}></Grid>
                </Grid>
            </Grid>
        );
    }
}

RaceEventEnd.propTypes = {
    type: PropTypes.string,
}

export default withStyles((theme) => ({
    circleBack: {
        border: 'solid 4px #FC2D33',
        borderRadius: 20,
        height: 40,
        width: 40,
    },
}))(RaceEventEnd);